/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ListinoAnimaliDettaglioCreateDTO
 */
export interface ListinoAnimaliDettaglioCreateDTO {
    /**
     * 
     * @type {number}
     * @memberof ListinoAnimaliDettaglioCreateDTO
     */
    idTipoAnimale?: number;
    /**
     * 
     * @type {Date}
     * @memberof ListinoAnimaliDettaglioCreateDTO
     */
    inizioValidita?: Date;
    /**
     * 
     * @type {number}
     * @memberof ListinoAnimaliDettaglioCreateDTO
     */
    valore?: number;
}

/**
 * Check if a given object implements the ListinoAnimaliDettaglioCreateDTO interface.
 */
export function instanceOfListinoAnimaliDettaglioCreateDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ListinoAnimaliDettaglioCreateDTOFromJSON(json: any): ListinoAnimaliDettaglioCreateDTO {
    return ListinoAnimaliDettaglioCreateDTOFromJSONTyped(json, false);
}

export function ListinoAnimaliDettaglioCreateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListinoAnimaliDettaglioCreateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idTipoAnimale': !exists(json, 'idTipoAnimale') ? undefined : json['idTipoAnimale'],
        'inizioValidita': !exists(json, 'inizioValidita') ? undefined : (new Date(json['inizioValidita'])),
        'valore': !exists(json, 'valore') ? undefined : json['valore'],
    };
}

export function ListinoAnimaliDettaglioCreateDTOToJSON(value?: ListinoAnimaliDettaglioCreateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idTipoAnimale': value.idTipoAnimale,
        'inizioValidita': value.inizioValidita === undefined ? undefined : (value.inizioValidita.toISOString()),
        'valore': value.valore,
    };
}

